/**
 * Pre-compiled en messages for DataTable
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  comfortable: `Comfortable`,
  comfortableAriaLabel: `Comfortable section`,
  compact: `Compact`,
  compactAriaLabel: `Compact section`,
  dataTable: `Data table`,
  dataTableBody: `Data table body`,
  dataTableHeader: `Data table header`,
  expandRows: `Expand rows`,
  fullText: `Full text`,
  fullTextAriaLabel: `Full text section`,
  hiddenColumns: `Hidden columns`,
  hiddenColumnsAriaLabel: `Hidden columns list`,
  hideColumn: `Hide column`,
  layoutSettings: `Layout settings`,
  layoutSettingsAriaLabel: `Layout settings section`,
  noHiddenColumns: `No Hidden columns`,
  pinRows: `Pin rows`,
  reset: `Reset columns`,
  resizeColumn: `Resize column`,
  rowDensity: `Row density`,
  rowDensityAriaLabel: `Row density section`,
  searchHiddenColumns: `Search...`,
  selectRow: `Select row`,
  settings: `Table settings`,
  settingsTabsAriaLabel: `Settings tabs`,
  textPreviews: `Text previews`,
  textPreviewsAriaLabel: `Text previews section`,
  textVisibility: `Text visibility`,
  textVisibilityAriaLabel: `Text visibility section`,
  visibleColumns: `Visible columns`,
  visibleColumnsAria: `Visible columns list`,
  visibleColumnsList: `Visible columns`,
};
